import styled from 'styled-components';
import TagsSelect from '../../../components/TagsSelect';

export const Container = styled.div``;

export const SelectMultiple = styled(TagsSelect)``;
